/**
 * Auto-capitalize the first letter of each word in a string.
 * Used for names, addresses, and company names in forms.
 * "john smith" → "John Smith"
 * "123 main street" → "123 Main Street"
 */
export function toTitleCase(str) {
  if (!str) return str;
  return str.replace(/(?:^|\s)\S/g, (char) => char.toUpperCase());
}
